
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RiverCurrentEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width } = pc;
        const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { y1, y2 } = this.getGridBounds(pc, spacing);
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = (1 / layerIndex) * scale;

        for (let y = y1; y <= y2; y += spacing) {
            const shift = Math.sin(curTime + y * 0.01) * 50;
            
            const draw = () => {
                ctx.beginPath();
                ctx.moveTo(-width * 2, y + shift);
                const points = 20;
                const step = (width * 4) / points;
                for (let i = -points/2; i <= points/2; i++) {
                    const x = i * step;
                    const dy = Math.sin(x * 0.005 + curTime * 2 + y) * 20;
                    ctx.lineTo(x, y + shift + dy);
                }
                ctx.stroke();
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
